export default [
    {
        backgroundImg: `assets/bgImgs/black.webp`,
        speakerName: `unset`,
        characterImg: `unset`,
        speakerTxt: `[In front of Millie and Anna's house ...]`,
        speakerTxtRS: `[Ispred Milicine i Anine kuće ...]`
    },
    {
        backgroundImg: `assets/bgImgs/house.webp`,
        speakerName: `Anna Adams`,
        speakerNameRS: `Ana Adamović`,
        characterImg: `assets/chars/anna/closedSmileCasual.webp`,
        speakerTxt: `"Well, it's getting pretty late. I should probably head in. See you next week."`,
        speakerTxtRS: `"Pa, postaje prilično kasno. Verovatno bi trebalo da krenem unutra. Vidimo se sledeće nedelje."`,
        dialogFx: `assets/dialog/anna/anna0036.mp3`,
    },
    {
        backgroundImg: `assets/bgImgs/black.webp`,
        speakerName: `unset`,
        characterImg: `unset`,
        speakerTxt: `[Same night ...]`,
        speakerTxtRS: `[Iste vačeri ...]`
    },
    {
        backgroundImg: `assets/bgImgs/diary.webp`,
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `Universe has time to fix everything. I feel like the happiest person in the world. I never knew a person could be the center of universe. My heart is pushing me towards her. I feel her existence around me. In my head, I talk to her, we laugh together.`,
        speakerTxtRS: `Univerzum ima vremena da sve popravi. Osećam se kao najsrećnija osoba na svetu. Nikada nisam znao da osoba može biti centar univerzuma. Srce me gura prema njoj. Osećam njeno postojanje oko sebe. U glavi pričam sa njom, smejemo se zajedno.`,
        dialogFx: `assets/dialog/joseph/joseph0095.mp3`,
        soundFx: `assets/sounds/writing.mp3`,
        soundLoop: true,
    },
    {
        backgroundImg: `assets/bgImgs/black.webp`,
        speakerTxt: `From next week, Anna's demeanor has changed, more cold and only work related. she later took week off. After that Anna quit the job altogether.`,
        speakerTxtRS: `Sledeće nedelje, Annino držanje se promenilo, hladnije i samo vezano za posao. Kasnije je uzela nedelju dana odmora. Nakon toga, Ana je potpuno napustila posao.`,
        dialogFx: `assets/dialog/joseph/joseph0096.mp3`,
    },
    {
        backgroundImg: `assets/bgImgs/black.webp`,
        speakerTxt: `Through Millie, I got details, her mother was in mental hospital, and she had to move back to be closer to her mother. I never saw or talked to her after that. Eventually she got married to her childhood friend from her city.`,
        speakerTxtRS: `Preko Milice sam saznao detalje, njena majka je bila u duševnoj bolnici i morala je da se vrati da bi bila bliže svojoj majci. Nikada je posle toga nisam video niti razgovarao sa njom. Na kraju se udala za prijatelja iz detinjstva iz njenog grada.`,
        dialogFx: `assets/dialog/joseph/joseph0097.mp3`,
    },
    {
        backgroundImg: `assets/bgImgs/diary.webp`,
        speakerTxt: `I've read in numerous manuscripts that everything in the world is made in pairs. But I have my doubts. I've been by myself and in solitude for half of my life. If this were the case, then why do the moon and sun shine and burn separately?`,
        speakerTxtRS: `Pročitao sam u brojnim rukopisima da se sve na svetu pravi u paru. Ali ja sumnjam. Polovinu života sam sam i u samoći. Ako je to slučaj, zašto onda mesec i sunce sijaju i gore odvojeno?`,
        dialogFx: `assets/dialog/joseph/joseph0098.mp3`,
        soundFx: `assets/sounds/writing.mp3`,
        soundLoop: true,
    },
    {
        speakerTxt: `Would I ever be free of this loneliness? Would I experience joy and reciprocal love? The things I want the most, will the universe ever grant them. The only conundrum life presents to me is one I am unable to solve. I can write the best codes and hack any website, but I am unable to discover the secret to a happy life.`,
        speakerTxtRS: `Da li ću ikada biti slobodan od ove usamljenosti? Da li ću iskusiti radost i uzajamnu ljubav? Stvari koje najviše želim, da li će univerzum ikada dati. Jedini zagonetni život koji mi se predstavlja je jedan koji ne mogu da rešim. Mogu da pišem najbolje kode i hakujem bilo koji sajt, ali ne mogu da otkrijem tajnu srećnog života.`,
        dialogFx: `assets/dialog/joseph/joseph0099.mp3`,
        soundFx: `assets/sounds/writing.mp3`,
        soundLoop: true,
    },
    {
        backgroundImg: `assets/bgImgs/black.webp`,
        speakerName: `unset`,
        speakerTxt: `THE END.`,
        speakerTxtRS: `KRAJ.`
    }
]